import React from 'react';

export const PlantWithiMac = props => (
  <svg width="222px" height="162px" viewBox="0 0 222 162" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-495.000000, -286.000000)">
        <g transform="translate(495.000000, 286.000000)">
          <path
            d="M169.569827,153.828286 L73.4303682,153.828286 L21.50857,101.847549 C20.8304767,101.168692 20.8304767,100.057914 21.50857,99.3790569 L120.267034,0.508488428 C120.945999,-0.169496143 122.054655,-0.169496143 122.732749,0.508488428 L221.492084,99.3790569 C222.169305,100.057914 222.169305,101.168692 221.492084,101.847549 L169.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <path
            d="M83.731,151.0287 L50.129,151.0287 C55.734,147.9247 56.008,129.2237 56.008,129.2237 L77.817,129.2237 C77.817,129.2237 77.351,148.4417 83.731,151.0287"
            fill="#FFFFFF"
          />
          <path
            d="M83.731,151.0287 L50.129,151.0287 C55.734,147.9247 56.008,129.2237 56.008,129.2237 L77.817,129.2237 C77.817,129.2237 77.351,148.4417 83.731,151.0287 Z"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M133.0215,128.851 C133.0215,130.501 131.6715,131.851 130.0215,131.851 L3.9455,131.851 C2.2955,131.851 0.9455,130.501 0.9455,128.851 L0.9455,50.458 C0.9455,48.808 2.2955,47.458 3.9455,47.458 L130.0215,47.458 C131.6715,47.458 133.0215,48.808 133.0215,50.458 L133.0215,128.851 Z"
            fill="#E2E8EE"
          />
          <path
            d="M133.0215,128.851 C133.0215,130.501 131.6715,131.851 130.0215,131.851 L3.9455,131.851 C2.2955,131.851 0.9455,130.501 0.9455,128.851 L0.9455,50.458 C0.9455,48.808 2.2955,47.458 3.9455,47.458 L130.0215,47.458 C131.6715,47.458 133.0215,48.808 133.0215,50.458 L133.0215,128.851 Z"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M56.1392,135.6908 L77.6972,138.3368 C77.6972,138.3368 77.5702,137.1728 77.3242,131.8508 C77.6022,130.1288 56.7572,129.3388 56.7572,129.3388 L56.1392,135.6908 Z"
            fill="#E2E8EE"
          />
          <path
            d="M133.0215,117.1635 C133.0215,115.3645 131.5495,113.8925 129.7505,113.8925 L4.2165,113.8925 C2.4175,113.8925 0.9455,115.3645 0.9455,117.1635 L0.9455,128.5805 C0.9455,130.3795 2.4175,131.8515 4.2165,131.8515 L129.7505,131.8515 C131.5495,131.8515 133.0215,130.3795 133.0215,128.5805 L133.0215,117.1635 Z"
            fill="#FFFFFF"
          />
          <path
            d="M133.0215,117.1635 C133.0215,115.3645 131.5495,113.8925 129.7505,113.8925 L0.9455,113.8925 L0.9455,128.5805 C0.9455,130.3795 2.4175,131.8515 4.2165,131.8515 L129.7505,131.8515 C131.5495,131.8515 133.0215,130.3795 133.0215,128.5805 L133.0215,117.1635 Z"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#FFFFFF"
            points="44.828 152.206 89.033 152.206 89.033 148.345 44.828 148.345"
          />
          <polygon
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="44.828 152.206 89.033 152.206 89.033 148.345 44.828 148.345"
          />
          <polygon
            fill="#FFFFFF"
            points="6.798 108.057 126.202 108.057 126.202 53.537 6.798 53.537"
          />
          <polygon
            fill="#FAFBFD"
            points="6.7984 108.057 126.2024 53.537 126.2024 108.057"
          />
          <path
            d="M157.5415,157.3891 C157.5415,159.6991 148.2345,161.5711 136.7545,161.5711 C125.2745,161.5711 115.9685,159.6991 115.9685,157.3891 C115.9685,155.0781 125.2745,153.2061 136.7545,153.2061 C148.2345,153.2061 157.5415,155.0781 157.5415,157.3891"
            fill="#D0D7DA"
          />
          <g transform="translate(112.000000, 113.710000)">
            <path
              d="M3.9688,16.4457 L6.3208,34.0497 C6.3208,38.3327 9.2008,41.8037 12.7538,41.8037 L36.8798,41.8037 C40.4328,41.8037 43.3128,38.3327 43.3128,34.0497 L48.6648,0.5997 L0.9688,0.5997 L2.9108,10.4107"
              fill="#FFFFFF"
            />
            <path
              d="M3.9688,16.4457 L6.3208,34.0497 C6.3208,38.3327 9.2008,41.8037 12.7538,41.8037 L36.8798,41.8037 C40.4328,41.8037 43.3128,38.3327 43.3128,34.0497 L48.6648,0.5997 L0.9688,0.5997 L2.9108,10.4107"
              stroke="#7350A0"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M153.4761,148.6401 C153.4761,152.8311 147.0271,153.6331 147.0271,153.6331 L152.1201,115.9281 L158.9021,115.9281 C158.9021,115.9281 153.4761,144.4491 153.4761,148.6401"
            fill="#F2F3F3"
          />
          <path
            d="M165.4908,153.2065 L190.2358,153.2065"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M195.3218,153.2065 L200.9008,153.2065"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M172.1656,106.9682 L172.1656,108.9682"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M172.1656,112.9682 L172.1656,114.9682"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M176.1656,110.9682 L174.1656,110.9682"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M170.1656,110.9682 L168.1656,110.9682"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M112.9727,100.2543 C112.9727,101.0933 112.2927,101.7733 111.4547,101.7733 C110.6167,101.7733 109.9367,101.0933 109.9367,100.2543 C109.9367,99.4163 110.6167,98.7363 111.4547,98.7363 C112.2927,98.7363 112.9727,99.4163 112.9727,100.2543"
            fill="#F5C400"
          />
          <path
            d="M171.6836,96.0121 C171.6836,96.8511 171.0036,97.5311 170.1656,97.5311 C169.3276,97.5311 168.6476,96.8511 168.6476,96.0121 C168.6476,95.1741 169.3276,94.4941 170.1656,94.4941 C171.0036,94.4941 171.6836,95.1741 171.6836,96.0121"
            fill="#0B9CE5"
          />
          <g transform="translate(135.000000, 99.710000)">
            <path
              d="M11.5064,0.766 C10.2274,-0.125 4.8114,1.414 2.4864,4.752 C0.1624,8.091 0.0114,12.321 2.3344,13.938 C4.6564,15.555 8.5714,13.947 10.8964,10.609 C13.2214,7.27 12.7854,1.657 11.5064,0.766"
              fill="#CBD62A"
            />
            <path
              d="M11.5064,0.766 C10.2274,-0.125 4.8114,1.414 2.4864,4.752 C0.1624,8.091 0.0114,12.321 2.3344,13.938 C4.6564,15.555 8.5714,13.947 10.8964,10.609 C13.2214,7.27 12.7854,1.657 11.5064,0.766"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(126.000000, 104.710000)">
            <path
              d="M0.3579,0.8597 C-0.3741,1.7107 0.3309,5.7037 2.5519,7.6137 C4.7729,9.5237 7.7919,9.9427 9.1209,8.3977 C10.4499,6.8527 9.5849,3.9297 7.3639,2.0197 C5.1429,0.1087 1.0899,0.0087 0.3579,0.8597"
              fill="#A3C23A"
            />
            <path
              d="M0.3579,0.8597 C-0.3741,1.7107 0.3309,5.7037 2.5519,7.6137 C4.7729,9.5237 7.7919,9.9427 9.1209,8.3977 C10.4499,6.8527 9.5849,3.9297 7.3639,2.0197 C5.1429,0.1087 1.0899,0.0087 0.3579,0.8597"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(137.000000, 107.710000)">
            <path d="M0.334,5.9379 L4.283,0.8189" fill="#CBD62A" />
            <path
              d="M0.334,5.9379 L4.283,0.8189"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(131.000000, 109.710000)">
            <path d="M0.6407,0.6117 L4.1207,3.3977" fill="#CBD62A" />
            <path
              d="M0.6407,0.6117 L4.1207,3.3977"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M118.0738,136.3959 L155.2798,136.3959"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#FFFFFF"
            points="163.7368 141.1381 157.0078 148.6401 144.7638 137.6571 146.0288 132.0221 151.4928 130.1561"
          />
          <polygon
            stroke="#83291B"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="163.7368 141.1381 157.0078 148.6401 144.7638 137.6571 146.0288 132.0221 151.4928 130.1561"
          />
          <path
            d="M148.6743,133.3998 C148.9453,133.6428 148.9673,134.0598 148.7243,134.3308 C148.4823,134.6018 148.0653,134.6248 147.7943,134.3808 C147.5233,134.1378 147.5003,133.7218 147.7433,133.4508 C147.9863,133.1798 148.4033,133.1568 148.6743,133.3998"
            fill="#FFFFFF"
          />
          <path
            d="M148.6743,133.3998 C148.9453,133.6428 148.9673,134.0598 148.7243,134.3308 C148.4823,134.6018 148.0653,134.6248 147.7943,134.3808 C147.5233,134.1378 147.5003,133.7218 147.7433,133.4508 C147.9863,133.1798 148.4033,133.1568 148.6743,133.3998 Z"
            stroke="#83291B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M118.0738,133.7699 L148.2898,133.7699"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M147.0274,79.5258 L147.0274,81.5258"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M147.0274,85.5258 L147.0274,87.5258"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M151.0274,83.5258 L149.0274,83.5258"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M145.0274,83.5258 L143.0274,83.5258"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M109.937,155.893 C109.937,158.584 101.791,160.767 91.741,160.767 C81.692,160.767 73.545,158.584 73.545,155.893 C73.545,153.202 81.692,151.019 91.741,151.019 C101.791,151.019 109.937,153.202 109.937,155.893"
            fill="#D0D7DA"
          />
          <g transform="translate(73.000000, 137.710000)">
            <polyline
              fill="#DDE5E8"
              points="4.814 0.8529 0.545 15.0039 6.914 15.0039"
            />
            <polyline
              stroke="#83291B"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="4.814 0.8529 0.545 15.0039 6.914 15.0039"
            />
          </g>
          <polygon
            fill="#FFFFFF"
            points="79.937 156.5844 109.937 156.5844 105.814 138.5634 77.814 138.5634"
          />
          <polygon
            stroke="#83291B"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="79.937 156.5844 109.937 156.5844 105.814 138.5634 77.814 138.5634"
          />
          <path
            d="M84.604,147.2358 C86.605,146.6968 88.32,145.1818 89.101,143.2618 C87.927,145.7098 87.122,148.3348 86.721,151.0188 C86.326,149.7328 86.454,148.2938 87.07,147.0968 C87.255,146.7378 87.506,146.3798 87.882,146.2318 C88.441,146.0118 89.077,146.3338 89.495,146.7648 C89.913,147.1968 90.208,147.7408 90.652,148.1438 C90.816,148.2928 91.009,148.4238 91.228,148.4508 C91.525,148.4858 91.805,148.3248 92.061,148.1688 C93.042,147.5708 94.022,146.9718 95.003,146.3738 C95.391,146.1368 95.833,145.8908 96.274,146.0018 C96.541,146.0678 96.758,146.2568 96.985,146.4128 C98.018,147.1238 99.463,147.1768 100.547,146.5458 C100.952,147.4528 102.32,147.2978 103.151,146.7558"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M67.0039,125.0902 C67.0039,126.0552 66.2219,126.8372 65.2569,126.8372 C64.2929,126.8372 63.5099,126.0552 63.5099,125.0902 C63.5099,124.1252 64.2929,123.3432 65.2569,123.3432 C66.2219,123.3432 67.0039,124.1252 67.0039,125.0902"
            fill="#DCE4E7"
          />
          <g transform="translate(152.000000, 48.710000)">
            <path d="M0.8457,0.9564 L19.1347,0.9564" fill="#FFFFFF" />
            <path
              d="M0.8457,0.9564 L19.1347,0.9564"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(152.000000, 57.710000)">
            <path d="M0.8457,0.8344 L28.9167,0.8344" fill="#FFFFFF" />
            <path
              d="M0.8457,0.8344 L28.9167,0.8344"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(166.000000, 68.710000)">
            <path d="M0.4141,0.0472 L25.4851,0.0472" fill="#FFFFFF" />
            <path
              d="M0.4141,0.0472 L25.4851,0.0472"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M163.125,49.6664 L163.125,58.5444"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M177.9083,58.5444 L177.9083,68.7574"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
